function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "\n    youtube\n  ");

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M38.15,10.88A4.74,4.74,0,0,0,34.8,7.53C31.85,6.74,20,6.74,20,6.74s-11.85,0-14.8.79a4.74,4.74,0,0,0-3.35,3.35c-.79,3-.79,9.12-.79,9.12s0,6.16.79,9.12A4.74,4.74,0,0,0,5.2,32.47c3,.79,14.8.79,14.8.79s11.85,0,14.8-.79a4.74,4.74,0,0,0,3.35-3.35c.79-3,.79-9.12.79-9.12S38.94,13.84,38.15,10.88ZM16.21,25.68V14.32L26.05,20Z",
  fill: "#231f20"
});

function SvgYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 40 40"
  }, props), _ref, _ref2);
}

export default SvgYoutube;